"use client";

import Button from "@/src/components/ui/Button";
import type { SpecializationType } from "@/src/lib/programs";
import { SpecializationImage } from "@/src/components/ui/FallbackImages";
import { Link } from "@/src/navigation";

const SpecializationCard = ({
  name,
  type,
  description,
  route,
}: SpecializationType) => {
  console.log(route);

  return (
    <div className="bg-white card-shadow rounded-lg rtl:border-r-[6px] ltr:border-l-[6px] border-primary w-full h-67 p-5">
      <div className="size-20 flex justify-center items-center mb-3 select-none">
        <SpecializationImage
          src={`/specializations/icons/${type}.svg`}
          alt={`Study ${name} - Academic specialization and degree program`}
          width={40}
          height={40}
          sizes="(max-width: 768px) 24px, 40px"
          iconClassName="size-10 text-primary"
          withBackground={false}
        />
      </div>
      <span className="text-primary title mb-2">{name}</span>
      <p className="small-text text-text-muted mb-2">{description}</p>
      <Link href={`/programs/${route}`}>
        <Button
          fill={"transparent"}
          leftArrow
          className="bg-transparent text-primary"
        >
          اقرأ المزيد
        </Button>
      </Link>
    </div>
  );
};

export default SpecializationCard;
